import PropTypes from 'prop-types';

import passengersPropType from './passengers';
import notesPropType from './notes';
import paymentsPropType from './payments';
import customerPropType from './customer';
import journeyPropType from './journey';
import feesPropType from './fees';
import hotelPropType from './hotel';

export default PropTypes.shape({
  totalPendingCancellationFarePrice: PropTypes.number,
  totalPendingCreationFarePrice: PropTypes.number,
  totalPriceToBePaid: PropTypes.number,
  totalExchangeFee: PropTypes.number,
  arePassengersEditable: PropTypes.bool,
  isLoyalty: PropTypes.bool,
  notes: notesPropType,
  payments: paymentsPropType,
  reference: PropTypes.string,
  status: PropTypes.string,
  fees: feesPropType,
  offlineFees: feesPropType,
  hotelCancellationFees: feesPropType,
  passengers: passengersPropType,
  customer: customerPropType,
  currency: PropTypes.string,
  totalPrice: PropTypes.number,
  outbound: journeyPropType,
  inbound: journeyPropType,
  isMigratedMulti: PropTypes.bool,
  isPackage: PropTypes.bool,
  hotels: PropTypes.arrayOf(hotelPropType),
  isBeingRepriced: PropTypes.bool,
  latestRevision: PropTypes.shape({
    username: PropTypes.string
  }),
  extraOnlyParentBookingReference: PropTypes.string,
  extraOnlyBookingReference: PropTypes.string
});
